import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    but_show:false,       //设备按钮，控制消防栓，阀门，水表按钮的显示隐藏
    pointData:[],         //点位信息
    watchisshow:true,     //水表图标显示隐藏
    famenisshow:true,     //阀门图标
    xiaofangisshow:true,  //消防图标
    give_water:true,      //给水图标
    give_xiaofang:true,   //消防给水图标
    pressdata:[],         //水表压力值信息，用于pressurebut组件判断管道显示颜色
    pressBut:true,        //压力按钮的显示
    environmentchange:true,   //控制透明度的禁用状态
    pageshow:false,          //控制二维面板在加载完成之后显示
    hours:'',                //获取时间的小时，用于控制警告弹框的显示
    tumingvalue:100,          //透明度数值,
    change_shebei: true       //控制设备管理得状态

  },
  getters: {
    f_PointData(state){
      state.pointData.forEach(item=>{
        if(item.pma_value!=undefined){
          item.pma_value=Number(item.pma_value).toFixed(2)+'MPa';
        }
      })
      return state.pointData
    },
    shaixuan(state){
      state.pressdata.forEach(item=>{
        item.pma_value = Number(item.pma_value).toFixed(2)
      })
      return state.pressdata
    }
  },
  mutations: { 
    changebutshow(state){
      state.but_show=!state.but_show
    },
    changebutshowfalse(state){
      state.but_show = false
    },
    butfalse(state){
      state.but_show = false
      // console.log('store')
    },
    getpointdata(state,data){
      state.pointData=data
    },
    changewatchshow_1(state){
      state.watchisshow=false
    },
    changewatchshow_2(state){
      state.watchisshow=!state.watchisshow
    },
    changewatchshow_3(state){
      state.watchisshow=true
    },
    changefamenshow_1(state){
      state.famenisshow=!state.famenisshow
    },
    changefamenshow_2(state){
      state.famenisshow=true
    },
    changexiaofangshow_1(state){
      state.xiaofangisshow=!state.xiaofangisshow
    },
    changexiaofangshow_2(state){
      state.xiaofangisshow=true
    },
    changegive_water_1(state){
      state.give_water=true
    },
    changegive_water_2(state){
      state.give_water=!state.give_water
    },
    changegive_xiaofang_1(state){
      state.give_xiaofang=true
    },
    changegive_xiaofang_2(state){
      state.give_xiaofang=!state.give_xiaofang
    },
    changepressbut_1(state){
      state.pressBut=true;
    },
    changepressbut_2(state){
      state.pressBut=!state.pressBut;
    },
    environmentchange_1(state){
      state.environmentchange=false
    },
    environmentchange_2(state){
      state.environmentchange=true
    },
    pageshowchange(state){
      state.pageshow=true;
    },
    tumingvaluechange(state){
      state.tumingvalue = 100;
    },
    change_shebei_but(state){
      state.change_shebei = !state.change_shebei
    },
    change_shebei_true(state){
      state.change_shebei = true;
    }
    

  },
  actions: {
  },
  modules: {
  }
})
